import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from '@gasbuddy/react-components';
import EmergencyStatusReport from '../../prop-types/emergency-status-report';
import styles from './OutageStatus.module.css';
import OutageStatusIcons from '../OutageStatusBadges';

export default function OutageStatus({ powerReport, gasReport, dieselReport, sellsDiesel }) {
  return (
    <div>
      <Panel className={styles.warningPanel} color="red">
        <img
          className={styles.warningIcon}
          src="//static.gasbuddy.com/web/icons/warning-white.svg"
          alt="Warning"
        />
        <p className={styles.message}>
          This station is in an area affected by a natural disaster. Help everyone out by reporting
          the status of power, gas, and diesel at this station.
        </p>
        <img
          className={styles.warningIcon}
          src="//static.gasbuddy.com/web/icons/warning-white.svg"
          alt="Warning"
        />
      </Panel>
      <OutageStatusIcons
        powerReport={powerReport}
        gasReport={gasReport}
        dieselReport={dieselReport}
        sellsDiesel={sellsDiesel}
      />
    </div>
  );
}

OutageStatus.propTypes = {
  powerReport: EmergencyStatusReport,
  gasReport: EmergencyStatusReport,
  dieselReport: EmergencyStatusReport,
  sellsDiesel: PropTypes.bool,
};

OutageStatus.defaultProps = {
  powerReport: {
    status: true,
  },
  gasReport: {
    status: true,
  },
  dieselReport: undefined,
  sellsDiesel: false,
};
